// Preload icons
const ICONS = {
  YES: `
    <svg width="15" height="15" class="me-2" viewBox="0 0 484 561" xmlns="http://www.w3.org/2000/svg">
      <path d="M459.16 34.223C418.715 22.399 332.85 0 242 0C151.15 0 65.29 22.398 24.84 34.223C10.528 38.5785 0.574005 51.645 0.574005 67.2V371.47C0.574005 381.427 4.92951 390.759 11.773 398.224C73.996 459.201 153.023 523.914 241.993 560.004C330.97 523.914 409.993 459.204 472.213 398.224C479.057 391.38 483.412 382.044 483.412 371.47V67.2C483.412 52.266 473.455 38.579 459.146 34.223H459.16ZM440.492 368.973C369.558 437.418 304.852 484.703 242.002 512.703C179.158 484.082 114.452 436.793 43.512 368.973V74.043C85.821 61.602 162.352 43.555 242.002 43.555C321.652 43.555 398.182 61.598 440.492 74.043V368.973Z" fill="currentColor"/>
      <path d="M223.96 363.38L132.491 273.157L161.112 244.536L220.225 303.024L332.225 163.024L363.959 187.911L223.96 363.38Z" fill="currentColor"/>
    </svg>
  `,
  NO: `
    <svg width="15" height="15" class="me-2" viewBox="0 0 484 561" xmlns="http://www.w3.org/2000/svg">
      <path d="M459.16 34.223C418.715 22.399 332.85 0 242 0C151.15 0 65.29 22.398 24.84 34.223C10.528 38.5785 0.574005 51.645 0.574005 67.2V371.47C0.574005 381.427 4.92951 390.759 11.773 398.224C73.996 459.201 153.023 523.914 241.993 560.004C330.97 523.914 409.993 459.204 472.213 398.224C479.057 391.38 483.412 382.044 483.412 371.47V67.2C483.412 52.266 473.455 38.579 459.146 34.223H459.16ZM440.492 368.973C369.558 437.418 304.852 484.703 242.002 512.703C179.158 484.082 114.452 436.793 43.512 368.973V74.043C85.821 61.602 162.352 43.555 242.002 43.555C321.652 43.555 398.182 61.598 440.492 74.043V368.973Z" fill="currentColor"/>
      <path d="M342.8 336.62L313.554 364.62L241.999 290.577L170.444 364.62L141.198 336.62L213.999 261.331L141.198 186.042L170.444 158.042L241.999 232.089L313.554 158.042L342.8 186.042L269.999 261.331L342.8 336.62Z" fill="currentColor"/>
    </svg>
  `,
};

// Preload images
const elem2 = document.getElementById("idash-assets-2");

// iDash flow schema
const data = JSON.parse(elem2.innerHTML || "{}").data;
// const data = [
//   {
//     id: "is-this-first-idash",
//     title: "Is This Your First iDash?",
//     options: [
//       {
//         title: "Yes, this is my 1st iDash",
//         action: { next: "how-will-you-connect" },
//         icon: ICONS.YES,
//       },
//       {
//         title: "No, I want to connect to another iDash",
//         action: { next: "expansion-record" },
//         icon: ICONS.NO,
//       },
//     ],
//   },
//   {
//     id: "how-will-you-connect",
//     title: "How will you connect to your vehicle?",
//     options: [
//       {
//         title: "I will use iDash as a stand-alone device",
//         action: { next: "standalone-record" },
//         image: images.obd_2,
//       },
//       {
//         title: "I already have a PedalMonster",
//         action: { next: "pedalmonster-record" },
//         image: images.pedalmonster,
//       },
//       {
//         title: "My vehicle doesn’t have OBD, 12-volt only",
//         action: { next: "no-obd" },
//         image: images.pre_obd,
//       },
//     ],
//   },
//   {
//     id: "pedalmonster-record",
//     title: "Do you Want to Record Vehicle Data & Play it Back Later?",
//     options: [
//       {
//         title: "Yes",
//         action: { product: "idash-data-pro-pedalmonster-upgrade-66715" },
//         icon: ICONS.YES,
//       },
//       {
//         title: "No",
//         action: { product: "idash-pro-pedalmonster-upgrade-66714" },
//         icon: ICONS.NO,
//       },
//     ],
//   },
//   {
//     id: "standalone-record",
//     title: "Do you Want to Record Vehicle Data & Play it Back Later?",
//     options: [
//       {
//         title: "Yes",
//         action: { product: "idash-data-pro-standalone-66711" },
//         icon: ICONS.YES,
//       },
//       {
//         title: "No",
//         action: { product: "idash-pro-standalone-66710" },
//         icon: ICONS.NO,
//       },
//     ],
//   },
//   {
//     id: "no-obd",
//     title: "Do you Want to Record Vehicle Data & Play it Back Later?",
//     options: [
//       {
//         title: "Yes",
//         action: { product: "idash-data-pro-no-obd-66718" },
//         icon: ICONS.YES,
//       },
//       {
//         title: "No",
//         action: { product: "idash-pro-no-obd-66717" },
//         icon: ICONS.NO,
//       },
//     ],
//   },
//   {
//     id: "expansion-record",
//     title: "Do you Want to Record Vehicle Data & Play it Back Later?",
//     options: [
//       {
//         title: "Yes",
//         action: { product: "idash-data-pro-expansion-gauge-66713" },
//         icon: ICONS.YES,
//       },
//       {
//         title: "No",
//         action: { product: "idash-pro-expansion-gauge-66712" },
//         icon: ICONS.NO,
//       },
//     ],
//   },
// ];

if (!customElements.get('custom-quiz-product')) {
  class CustomQuizProduct extends HTMLElement {
    constructor() {
      super();
      this.data = data;
      this.startingIndex = this.data[0];
      this.icons = ICONS;
      this.question = this.querySelector('[data-quiz-question]');
      this.answers = this.querySelector('[data-quiz-answers]');
      this.history = [];
      this.quizBody = this.querySelector('#QuizProductModel-Content');
      this.init();
    }

    setupAllFunnel() {
      this.data.map((data, index) => {
        var answerHTML = "";
        data.options.map((option, index) => {
          answerHTML += `
          <div class="position-relative mb-3">
            <input type="radio" class="quiz-input ${option.image ? 'has-image' : ''} cursor-pointer position-absolute w-100 h-100" value="${option.title}" name="${data.id}" id="${data.id}-${index}" data-answer-submit data-answer-key="${Object.keys(option.action)[0]}" data-answer-value="${Object.values(option.action)[0]}" />
            <label for="${data.id}-${index}" class="btn-white button fw-medium rounded-1-5 text-uppercase w-100 ${option.image ? 'py-0 justify-content-between' : 'justify-content-start'}">
              <div class="text-start d-flex align-items-center">
                ${option.icon ? option.icon == "ICONS.YES" ? ICONS.YES : ICONS.NO : ""}
                <span>${option.title}</span>
              </div>
              ${option.image ? `<img src="${option.image}" loading="lazy" width="80" height="80" />` : ""}
            </label>
          </div>
          `;
        })
        if (data.id != this.startingIndex.id) {
          answerHTML += `
            <button class="accent button fw-medium rounded-1-5 text-uppercase w-100 mb-3" data-answer-submit data-answer-key="prev" data-answer-value="">
              <span>Previous</span>
            </button>
          `;
        }
        var html = `
          <div class="d-none ${index}" data-quiz-id="${data.id}">
            <div class="font-acumin mt-2 fw-acumin-800 text-uppercase model-title h2" data-quiz-question>${data.title}</div>
            <div class="form-botter-area mt-3" data-quiz-answers>
            ${answerHTML}
            </div>
          </div>
        `;
        this.quizBody.insertAdjacentHTML("afterbegin", html);
      })
      this.setupSection(this.data[0].id);
      this.listenDataSubmitEvent();
    }

    setupSection(questionId) {
      this.querySelectorAll('[data-quiz-id]').forEach(quiz => quiz.classList.add('d-none'));
      this.querySelector(`[data-quiz-id="${questionId}"]`)?.classList.remove('d-none');
      this.history.push(questionId);
    }

    listenDataSubmitEvent(){
      const that = this;
      var submitButtons = this.querySelectorAll('[data-answer-submit]');
      submitButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
          var key = btn.getAttribute('data-answer-key');
          var value = btn.getAttribute('data-answer-value');
          that.nextPhase(key, value);
        })
      })
    }

    nextPhase(key, value) {
      if (key == "next") {
        this.setupSection(value);
      } else if (key == "product") {
        window.location.href = `/products/${value}`;
      } else if(key == "prev") {
        this.history.pop();
        var value = this.history.pop();
        this.setupSection(value);
      }
    }

    init() {
      this.setupAllFunnel();
    }
  }
  customElements.define('custom-quiz-product', CustomQuizProduct);
}